var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitionCarouselLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7399 22.4274C17.4348 22.7325 16.9402 22.7325 16.6351 22.4274L7.26007 13.0524C6.95498 12.7473 6.95498 12.2527 7.26007 11.9476L16.6351 2.57257C16.9402 2.26748 17.4348 2.26748 17.7399 2.57257C18.045 2.87767 18.045 3.37233 17.7399 3.67743L8.91735 12.5L17.7399 21.3226C18.045 21.6277 18.045 22.1223 17.7399 22.4274Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitionCarouselLeft);
export default __webpack_public_path__ + "static/media/CompetitionCarouselLeft.f4f908bebc39c8eb8b7f75d18a886f5e.svg";
export { ForwardRef as ReactComponent };